/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var ButtonVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ButtonVisualModelExport, _super);
    function ButtonVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.s = 0;
        _this.q = 0;
        _this.p = 0;
        _this.t = 0;
        _this.h = 0;
        _this.i = 0;
        _this.c = null;
        _this.g = null;
        _this.d = null;
        _this.a = null;
        _this.u = 0;
        _this.e = null;
        _this.ah = null;
        _this.b = null;
        _this.j = 0;
        _this.f = null;
        _this.o = 0;
        _this.ae = null;
        _this.af = null;
        _this.ag = null;
        _this.r = 0;
        _this.ac = null;
        _this.ad = null;
        _this.x = null;
        _this.y = null;
        _this.z = null;
        _this.w = null;
        _this.v = null;
        _this.aa = null;
        _this.m = false;
        _this.k = false;
        _this.n = false;
        _this.l = false;
        return _this;
    }
    ButtonVisualModelExport.prototype.ab = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("top : " + this.s + ", ");
        a.l("left : " + this.q + ", ");
        a.l("height : " + this.p + ", ");
        a.l("width : " + this.t + ", ");
        a.l("baseTheme : " + this.h + ", ");
        a.l("actualDensity : " + this.i + ", ");
        a.l("actualBorderColor : " + this.c.serialize() + ", ");
        a.l("actualUmbraShadowColor : " + this.g.serialize() + ", ");
        a.l("actualPenumbraShadowColor : " + this.d.serialize() + ", ");
        a.l("actualAmbientShadowColor : " + this.a.serialize() + ", ");
        a.l("actualRestingElevation : " + this.u + ", ");
        if (this.e != null) {
            a.l("actualRippleColor : " + this.e.serialize() + ", ");
        }
        a.l("actualBackgroundColor : " + this.b.serialize() + ", ");
        a.l("actualElevationMode : " + this.j + ", ");
        a.l("actualTextColor : " + this.f.serialize() + ", ");
        a.l("actualBorderWidth : " + this.o + ", ");
        if (!stringIsNullOrEmpty(this.ae)) {
            a.l("textStyleFontStyle : \"" + this.ae + "\", ");
        }
        if (!stringIsNullOrEmpty(this.af)) {
            a.l("textStyleFontVariant : \"" + this.af + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ag)) {
            a.l("textStyleFontWeight : \"" + this.ag + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ac)) {
            a.l("textStyleFontFamily : \"" + this.ac + "\", ");
        }
        if (!stringIsNullOrEmpty(this.ad)) {
            a.l("textStyleFontStretch : \"" + this.ad + "\", ");
        }
        if (!isNaN_(this.r)) {
            a.l("textStyleFontSize : " + this.r + ", ");
        }
        a.l("display : \"" + this.x + "\", ");
        a.l("flexDirection : \"" + this.y + "\", ");
        a.l("flexGrow : \"" + this.z + "\", ");
        a.l("alignItems : \"" + this.w + "\", ");
        if (this.v != null) {
            a.l("value : \"" + this.v.toString() + "\", ");
        }
        a.l("name : \"" + this.aa + "\", ");
        a.l("isFocused : " + this.m + ", ");
        a.l("actualDisableRipple : " + this.k + ", ");
        a.l("isHover : " + this.n + ", ");
        a.l("isDisabled : " + this.l + ", ");
        a.l("}");
        return a.toString();
    };
    ButtonVisualModelExport.$t = markType(ButtonVisualModelExport, 'ButtonVisualModelExport');
    return ButtonVisualModelExport;
}(Base));
export { ButtonVisualModelExport };
//# sourceMappingURL=ButtonVisualModelExport.js.map
